/**
 * Created by rickborst on 01/03/2017.
 */

import _ from 'lodash';

/**
 * Parse the response from get user info request.
 *
 * @param {Object} data - Response data.
 * @returns {Object} Name, id... Of the user.
 */
function convertFromRead (data) {

    return {
        id: data.id || '',
        username: data.username || '',
        householdId: data.householdId || '',
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        phone: data.phone || '',
        address: data.address || '',
        zip: data.zip || '',
        city: data.city || '',
        countryId: data.countryId || '',
        facebookId: data.facebookId || '',
        facebookImage: data.facebookImage || '',
        facebookToken: data.facebookToken || '',
        isMasterUser: data.isHouseholdMaster || '',
        suspensionState: data.suspensionState || '',
        userState: data.userState || '',
        apiSpecifics: {
            externalId: data.externalId || '',
            affiliateCode: data.affiliateCode || '',
            objectType: data.objectType || '',
            userType: data.userType || null,
            dynamicData: data.dynamicData || {}
        }
    };
}

/**
 * Parse the response from authetication request.
 *
 * @param {Object} data - Response data.
 * @returns {Object} Name, id... Of the user.
 */
function convertFromAuthentication (data) {

    return convertFromRead.call(this, data);
}

/**
 * Parse the response from get active user request.
 *
 * @param {Object} response - Response data.
 * @returns {Object} Name, id... Of the user.
 */
function convertFromGetActiveUser (response) {
    let data = response.result;

    return convertFromRead.call(this, data);
}

/**
 * Parse a User instance to update user data.
 *
 * @param {Object} user - User instance.
 * @returns {Object} Update user data.
 */
function convertForUpdateUser (user) {
    let data = {
        user: {
            firstName: user.firstName || '',
            lastName: user.lastName || '',
            email: user.email || '',
            phone: user.phone || '',
            address: user.address || '',
            zip: user.zip || '',
            city: user.city || '',
            countryId: user.countryId || 0
        }
    };

    // Protection from un-setting critical values by accident.
    if (!_.isUndefined(user.username)) {
        data.user.username = user.username;
    }
    if (_.get(user, ['apiSpecifics', 'dynamicData'])) {
        data.user.dynamicData = user.apiSpecifics.dynamicData;
    }

    return data;
}

/**
 * Prepare request payload for users registration.
 *
 * @param {Object} registerFormData - Register form data.
 * @returns {Object} Update user data.
 */
function convertForRegisterUser (registerFormData) {
    let data = {
        password: registerFormData.password || '',
        partnerId: this._presets.partnerId || 0,
        user: {
            username: registerFormData.email || '',
            firstName: registerFormData.firstName || '',
            lastName: registerFormData.lastName || '',
            email: registerFormData.email || '',
            phone: registerFormData.phone || '',
            address: registerFormData.address ? registerFormData.address + (registerFormData.number ? ' ' + registerFormData.number : '') || '' : '',
            zip: registerFormData.zip || '',
            city: registerFormData.city || '',
            countryId: registerFormData.countryId || 0,
            dynamicData: {
                'tc_version': {
                    objectType: 'KalturaStringValue',
                    description: 'TC version',
                    value: registerFormData.tc_version || ''
                },
                'pp_version': {
                    objectType: 'KalturaStringValue',
                    description: 'PP version',
                    value: registerFormData.pp_version || ''
                }
            }

            // dynamicData: {
            //     'gender': {
            //         objectType: 'KalturaStringValue',
            //         description: 'Gender',
            //         value: registerFormData.gender || ''
            //     },
            //     'birthDate': {
            //         objectType: 'KalturaStringValue',
            //         description: 'Date of birth',
            //         value: registerFormData.birthDate?.replace('_', '') || ''
            //     }
            // }
        }
    };

    return data;
}

/**
 * Converts application data to entitlements request data.
 *
 * @returns {Object} Request data.
 */
function convertForEntitlements () {

    return {
        filter: {
            objectType: 'KalturaEntitlementFilter',
            orderBy: 'PURCHASE_DATE_DESC',
            entitlementTypeEqual: 'subscription',
            entityReferenceEqual: 'user',
            isExpiredEqual: false
        },
        pager: {
            pageIndex: 1,
            pageSize: 100
        }
    };
}

/**
 * Converts entitlements response to application data.
 *
 * @param {Object} response - Entitlements response.
 * @returns {Object} Converted data.
 */
function convertFromEntitlements (response) {
    let data = _.get(response, ['result', 'objects'])[0] || {};

    return {
        id: data.id || null,
        currentDate: data.currentDate ? data.currentDate * 1000 : null,
        endDate: data.endDate ? data.endDate * 1000 : null,
        lastViewDate: data.lastViewDate ? data.lastViewDate * 1000 : null,
        purchaseDate: data.purchaseDate ? data.purchaseDate * 1000 : null,
        renewableForPurchase: data.isRenewableForPurchase || false,
        renewable: data.isRenewable || false,
        type: data.type || '',
        uses: data.currentUses || 0,
        maxUses: data.maxUses || 0,
        paymentMethod: data.paymentMethod || '',
        deviceUdid: data.deviceUdid || '',
        deviceName: data.deviceName || '',
        apiSpecifics: {
            isInGracePeriod: data.isInGracePeriod || false,
            entitlementId: data.entitlementId || '',
            purchaseId: data.purchaseId || '',
            isCancelationWindowEnabled: data.isCancelationWindowEnabled || false,
            mediaFileId: data.mediaFileId || 0,
            mediaId: data.mediaId || 0,
            householdId: data.householdId || 0,
            objectType: data.objectType || ''
        }
    };
}

/**
 * Converts application data to subscription request data.
 *
 * @param {Object} entitlement - Entitlement.
 * @returns {Object} Request data.
 */
function convertForSubscriptions (entitlement) {

    return {
        filter: {
            objectType: 'KalturaSubscriptionFilter',
            orderBy: 'START_DATE_DESC',
            subscriptionIdIn: entitlement
        }
    };
}

/**
 * Converts subscriptions response to application data.
 *
 * @param {Object} response - Subscriptions response.
 * @returns {Object} Converted data.
 */
function convertFromSubscriptions (response) {
    let data = _.get(response, ['result', 'objects'])[0] || {};

    return {
        id: data.id || '',
        startDate: data.startDate ? data.startDate * 100 : null,
        endDate: data.endDate ? data.endDate * 100 : null,
        renewable: data.isRenewable || false,
        renewals: data.renewalsNumber || 0,
        infinitelyRenewable: data.isInfiniteRenewal || false,
        price: {
            amount: _.get(data, ['price', 'price', 'amount']) || null,
            currency: _.get(data, ['price', 'price', 'currency']) || null,
            sign: _.get(data, ['price', 'price', 'currencySign']) || ''
        },
        discount: {
            percent: _.get(data, ['discountModule', 'percent']) || 0,
            startDate: _.get(data, ['discountModule', 'startDate']) || null,
            endDate: _.get(data, ['discountModule', 'endDate']) || null
        },
        name: data.name || '',
        description: data.description || '',
        order: _.get(data, ['prorityInOrder']) // TODO: <- Remove typo fallback
        || _.get(data, ['priorityInOrder'])
        || 0,
        maxViews: data.maxViewsNumber || 0,

        apiSpecifics: {
            channels: data.channels || [],
            fileTypes: data.fileTypes || [],
            mediaId: data.mediaId || 0,
            pricePlans: data.pricePlans || [],
            householdLimitationsId: data.householdLimitationsId || null,
            gracePeriodMinutes: data.gracePeriodMinutes || 0,
            premiumServices: data.premiumServices || [],
            viewLifeCycle: data.viewLifeCycle || null,
            waiverPeriod: data.waiverPeriod || 0,
            isWaiverEnabled: data.isWaiverEnabled || false,
            userTypes: data.userTypes || [],
            couponsGroups: data.couponsGroups || [],
            productCodes: data.productCodes || [],
            objectType: data.objectType || ''
        }
    };
}

/**
 * Converts application data to payment method request data.
 *
 * @returns {Object} Request data.
 */
function convertForPaymentMethod () {

    return {
        householdPaymentMethod: {
            isDefault: true
        }
    };
}

/**
 * Converts payment method response to application data.
 *
 * @param {Object} response - Payment method response.
 * @returns {Object} Converted data.
 */
function convertFromPaymentMethod (response) {
    let entries = _.get(response, ['result', 'objects']),
        defaultMethod = _.find(entries, ['isDefault', true]) || {},
        details = (defaultMethod.details || '').split('|');

    return {
        id: defaultMethod.id || '',
        method: details[1] || null,
        lastDigits: details[3] || '',
        selected: defaultMethod.selected || false,
        apiSpecifics: {
            externalId: defaultMethod.externalId || '',
            isDefault: defaultMethod.isDefault || false,
            objectType: defaultMethod.objectType || '',
            paymentGatewayId: defaultMethod.paymentGatewayId || 0,
            paymentMethodProfileId: defaultMethod.paymentMethodProfileId || 0
        }
    };
}

/**
 * Converts payment details responses to application data.
 *
 * @param {Object} responses - Payment details responses.
 * @returns {Object} Converted data.
 */
function convertFromPaymentDetails (responses) {
    let entitlement = responses[0] || {},
        subscription = responses[1] || {},
        paymentMethod = responses[2] || {};

    return {
        type: entitlement.type || '',
        renewable: subscription.renewable || false,
        endDate: entitlement.endDate || null,
        subscriptionId: subscription.id || null,
        method: paymentMethod.method || '',
        lastDigits: paymentMethod.lastDigits || '',
        paymentGatewayId: paymentMethod.apiSpecifics.paymentGatewayId || '',
        subscriptionName: subscription.name || ''
    };
}

/**
 * Converts data for change password request.
 *
 * @param {Object} data - User data.
 * @returns {Object} Converted data.
 */
function convertForChangePassword (data) {
    return {
        username: data.username || '',
        oldPassword: data.oldPassword || '',
        newPassword: data.newPassword || ''
    };
}

/**
 * Converts data for create household.
 *
 * @param {Object} data - Household data.
 * @returns {Object} Converted data.
 */
function convertForCreateHousehold (data) {
    return {
        household : {
            objectType: 'KalturaHousehold',
            name: data.name || '',
            description: data.name || '',
            externalId: data.name || ''
        }
    };
}

export {
    convertFromRead,
    convertFromAuthentication,
    convertFromGetActiveUser,
    convertForUpdateUser,
    convertForRegisterUser,
    convertForEntitlements,
    convertForSubscriptions,
    convertForPaymentMethod,
    convertFromEntitlements,
    convertFromSubscriptions,
    convertFromPaymentMethod,
    convertForChangePassword,
    convertFromPaymentDetails,
    convertForCreateHousehold
};



// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/adapters/users.js